import React, { createRef, useState, useEffect } from "react";
import "./Header.scss";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faLongArrowAltLeft,
  faPhone,
  faWindowClose,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import SearchField from "./SearchField";

import logo from "./images/logo-2.png";

const Header = () => {
  const [opaque, setOpaque] = useState(false);
  const [viewSidebar, setViewSidebar] = useState(false);
  const [showSearchField, setShowSearchField] = useState(false);
  const searchRef = createRef();

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (showSearchField) {
      searchRef.current.focus();
    }
  }, [searchRef, showSearchField]);

  const links = [
    {
      title: "Services",
      destination: "/services",
    },
    {
      title: "Styles",
      destination: "/styles/style",
    },
    {
      title: "Gallery",
      destination: "/gallery",
    },
    {
      title: "About",
      destination: "/about-us",
    },
    {
      title: "Contact",
      destination: "/contact-us",
    },
  ];

  const mapLinks = () => {
    return links.map((link, index) => {
      return (
        <div className="col navigation-link no-side-padding" key={index}>
          <Link to={link.destination}>
            <button>
              {link.title} <hr className="transition-3" />
            </button>
          </Link>
        </div>
      );
    });
  };

  const mapMobileLinks = () => {
    let mobileLinks = [
      {
        title: "Home",
        destination: "/",
      },
      ...links,
    ];

    return mobileLinks.map((link, index) => {
      return (
        <li key={index}>
          <Link to={link.destination}>
            <button onClick={() => setViewSidebar(!viewSidebar)}>
              {link.title} <hr className="transition-3" />
            </button>
          </Link>
        </li>
      );
    });
  };

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setOpaque(true);
    } else {
      setOpaque(false);
    }
  };

  return (
    <div
      className={`container-fluid header-navigation ${
        opaque ? "header-scrolled" : ""
      } transition-3`}
    >
      <div className="row justify-content-center">
        <div className="col-7 col-md-4 col-lg-5 col-xl-3 title">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="col-md-8 col-lg-6 col-xl-6  offset-xl-2 links-wrapper mobile-hidden">
          <div className="row">{mapLinks()}</div>
        </div>
        <div className="col-2 col-md-6 text-right my-auto lap-hidden desktop-hidden no-side-padding">
          <a href="tel:+18182758613">
            <button className="transition-3 mobile-button">
              <FontAwesomeIcon icon={faPhone} />
            </button>
          </a>
        </div>
        {/* Search button */}
        <div className="search">
          <button
            className="search-icon"
            onClick={() => setShowSearchField((a) => !a)}
          >
            <FontAwesomeIcon
              icon={showSearchField ? faWindowClose : faSearch}
            />
          </button>
        </div>
        <div className="col-2 col-md-1 my-auto mobile-burger transition-3 lap-hidden desktop-hidden no-side-padding">
          <button
            className="transition-3 mobile-button"
            onClick={() => setViewSidebar(!viewSidebar)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </div>
      <button
        className={`mobile-background ${
          viewSidebar ? "background-reveal" : ""
        }`}
        onClick={() => setViewSidebar(!viewSidebar)}
      ></button>
      <div
        className={`mobile-sidebar transition-3 ${
          viewSidebar ? "sidebar-reveal" : ""
        }`}
      >
        <button
          className="transition-3 mobile-button"
          onClick={() => setViewSidebar(!viewSidebar)}
        >
          <FontAwesomeIcon icon={faLongArrowAltLeft} />
        </button>
        <ul>{mapMobileLinks()}</ul>
      </div>
      {showSearchField && (
        <SearchField
          inputRef={searchRef}
          setShowSearchField={setShowSearchField}
        />
      )}
    </div>
  );
};

export default Header;
